const IDENTIFY_ATTRIBUTES = {
  id: "modules/analytics/schema/identifyAttributes",
  type: "object",
  properties: {
    user_analytics_id: {
      type: "string",
    },
    user_email: {
      type: "string",
    },
  },
  required: ["user_analytics_id", "user_email"],
}

export default IDENTIFY_ATTRIBUTES
